import { LIVE_BASE_URL, STAGE_BASE_URL, STUDIO_API_PREFIX } from '../src/client/lib/constants';
import { trackLinkClick, trackKeyboardCopy } from '../src/client/lib/fpti';
import ImagePopUp from '../src/client/components/ImagePopUp';
import { paymentComponentModalTempHack } from '../src/client/Page/Fastlane/PreviewWrapper/helpers';
import hashNavigate from '../src/client/util/hashNavigation';

const windowFetch = window.fetch;

function isStudioApiCall(url) {
  return url.indexOf(STUDIO_API_PREFIX) > -1;
}

function getEnvBaseUrl() {
  try {
    const targetEnv = document.getElementsByTagName('body')[0].dataset.env;
    if (targetEnv === 'production') {
      return LIVE_BASE_URL;
    }

    return STAGE_BASE_URL;
  } catch (e) {
    return LIVE_BASE_URL;
  }
}

const baseUrl = getEnvBaseUrl();
const loginRedirectUrl = `${baseUrl}/signin/?returnUri=`;

function patchFetch() {
  window.fetch = async (url, options) => {
    try {
      const result = await windowFetch(url, options);
      if ([401, 403].includes(result.status) && isStudioApiCall(url)) {
        /**
         * As we are patching the global fetch method, redirect should happen only
         * when APIs which belong to studio respond with a 401 or 403 status code.
         * Other calls from SDK, FPTI, 3rd Party vendors should not be affected.
         */
        window.location.href = `${loginRedirectUrl}${window.location.href}`;
      }
      return result;
    } catch (err) {
      return Promise.reject(err);
    }
  };
}

patchFetch();

document.body.addEventListener('click', (e) => {
  const targetElement = e.target;
  if (targetElement.tagName === 'PAYPAL-PAYMENT') {
    paymentComponentModalTempHack();
  }
  if (targetElement.tagName === 'A') {
    const text = targetElement.innerText;
    const link = targetElement.getAttribute('href');
    trackLinkClick(text, link);
  }

  if (targetElement.getAttribute('data-popup')) {
    e.preventDefault();
    const imgUrl = targetElement.getAttribute('href');
    ImagePopUp(imgUrl);
  }
});

const anchor = window.location.href.split('#')[1];
if (anchor) {
  history.scrollRestoration = 'manual';
  hashNavigate(anchor);
} else {
  history.scrollRestoration = 'auto';
}
